export const TIME_OUT_MS = 30000;
export const APP_NAME = "PICK ONE";
